import { forwardRef, type Ref, type SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  title?: string;
};

const TargetIcon = (
  { title = "Target Icon", style, ...props }: Props,
  ref: Ref<SVGSVGElement>
) => {
  const ariaLabel = props["aria-label"];
  const isAriaHidden = ariaLabel == null && title == null;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 19"
      width="1em"
      height="1em"
      fill="none"
      ref={ref}
      role={isAriaHidden ? undefined : "img"}
      aria-hidden={isAriaHidden ? true : undefined}
      style={{ color: "#697586", ...style }}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M12.5 5.83337V3.33337L15 0.833374L15.8333 2.50004L17.5 3.33337L15 5.83337H12.5ZM12.5 5.83337L9.16668 9.16666M17.5 9.16671C17.5 13.7691 13.7691 17.5 9.16671 17.5C4.56433 17.5 0.833374 13.7691 0.833374 9.16671C0.833374 4.56433 4.56433 0.833374 9.16671 0.833374M13.3334 9.16671C13.3334 11.4679 11.4679 13.3334 9.16671 13.3334C6.86552 13.3334 5.00004 11.4679 5.00004 9.16671C5.00004 6.86552 6.86552 5.00004 9.16671 5.00004"
        stroke="currentColor"
        strokeWidth={1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default forwardRef(TargetIcon);
